<template>
  <section class="visual-settings settings">
    <header>
      <h1 class="page-header">Visual</h1>
    </header>
    <h3>Grid square colors</h3>
    <div class="row">
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="gridSquareColors"
              type="radio"
              value="multicolored"
            >
            Multicolored grid squares
            <img src="/static/settings/visual/multicolored-grid-squares.png">
            Advantages:
            <ul>
              <li>Easily distinguish between suited, offsuit and paired hands</li>
              <li>More aesthetically pleasing?</li>
            </ul>
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="gridSquareColors"
              type="radio"
              value="green"
            >
            Green grid squares
            <img src="/static/settings/visual/green-grid-squares.png">
            Advantages:
            <ul>
              <li>Easily tell how many combos of the grid square are in range</li>
            </ul>
          </label>
        </div>
      </div>
    </div>
    <hr>
    <h3>Show number of combos in range?</h3>
    <div class="row">
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="areNumCombosInRangeVisible"
              type="radio"
              value="false"
            >
            Don't show number of combos in range
            <img src="/static/settings/visual/dont-show-num-combos-in-range.png">
          </label>
        </div>
      </div>
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="areNumCombosInRangeVisible"
              type="radio"
              value="true"
            >
            Show number of combos in range
            <img src="/static/settings/visual/show-num-combos-in-range.png">
          </label>
        </div>
      </div>
    </div>
    <hr>
    <h3>Setting hand weights</h3>
    <div class="row">
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="settingHandWeights"
              type="radio"
              value="verticalSetWeightToApplyToAddedHandsSliderBasic"
            >
            Vertical set weight to apply to added hands (basic)
          </label>
        </div>
        <section class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/SUGkNdLVo0M?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </section>
      </div>
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="settingHandWeights"
              type="radio"
              value="verticalSetWeightToApplyToAddedHandsSliderWithSettings"
            >
            Vertical set weight to apply to added hands with settings
          </label>
        </div>
        <section class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/NABjiewbPxY?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </section>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="radio">
          <label>
            <input
              v-model="settingHandWeights"
              type="radio"
              value="setWeightToApplyToAddedHandsModal"
            >
            Set weight to apply to added hands modal
          </label>
        </div>
        <section class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/g0G6bIToh_A?rel=0&amp;showinfo=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </section>
      </div>
    </div>
    <hr>
    <button
      class="btn btn-primary btn-lg"
      v-on:click="save()"
    >Save</button>
  </section>
</template>

<script>
export default {
  name: 'visual-settings',
  data: function () {
    let settingsState = this.$store.state.account.user.settings;

    return {
      gridSquareColors: settingsState.general.visual.gridSquareColors,
      areNumCombosInRangeVisible: settingsState.general.visual.areNumCombosInRangeVisible,
      settingHandWeights: settingsState.general.visual.settingHandWeights,
    };
  },
  methods: {
    save: function () {
      let self = this;
      let user = _.cloneDeep(this.$store.state.account.user);

      user.settings.general.visual = {
        gridSquareColors: this.gridSquareColors,
        areNumCombosInRangeVisible: this._getAreNumCombosInRangeVisibleValue(),
        settingHandWeights: this.settingHandWeights,
      };
      self.$http.put(`${process.env.BASE_API_URL}/user`, { user: user }).then(function (res) {
        self.$store.commit('account/setUser', res.data.user);
        alert('Saved!');
      }).catch(function () {
        alert('Unable to save settings.');
      });
    },
    _getAreNumCombosInRangeVisibleValue: function () {
      let areNumCombosInRangeVisible = this.areNumCombosInRangeVisible;

      if (areNumCombosInRangeVisible === 'true') {
        areNumCombosInRangeVisible = true;
      } else if (areNumCombosInRangeVisible === 'false') {
        areNumCombosInRangeVisible = false;
      } else if (typeof areNumCombosInRangeVisible !== 'boolean') {
        throw new Error('Unexpected type for areNumCombosInRangeVisible: ', areNumCombosInRangeVisible);
      }

      return areNumCombosInRangeVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  @import 'src/assets/settings';

  img {
    display: block;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/settings/general/visual.vue